export default {"src":"/_next/static/media/ARKG.b6d5026b.svg","height":18,"width":18};